// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1018":"3108b1c2","3449":"3108b1c2"}[chunkId] + ".chunk.css";
};